// Retentativa do drain armada PELA FALHA (BEL-1751).
//
// NÃO é um heartbeat. Um `setInterval` a sondar a fila seria a quinta roda: já
// existem quatro caminhos que drenam (captura, autosync, pull-resume, Background
// Sync) e, com o listener de `connection change`, a própria mudança de rede
// também dispara. O que nenhum deles cobre é a falha SEM mudança de rede — o
// servidor responde 429/408, as ops ficam na fila, e nada volta a acontecer
// porque nada mudou.
//
// A resposta é a mesma primitiva que o Horizon usa do lado do servidor: quem
// falha agenda a própria tentativa seguinte, com backoff a subir. Três
// propriedades que o distinguem de polling:
//   1. só existe depois de uma falha, nunca em repouso;
//   2. auto-cancela quando a fila esvazia ou outro gatilho drena com sucesso;
//   3. a escada é finita — esgotada, cala-se e devolve o trabalho aos eventos.

/**
 * Degraus da escada, em ms. ~7 min no total. Depois disto, se a rede continua
 * indisponível, um evento (connection change, online, focus) chegará muito antes
 * de valer a pena continuar a tentar sozinho.
 */
export const RETRY_BACKOFF_MS = [5000, 15000, 45000, 120000, 120000, 120000];

let timer = null;
let attempt = 0;

/** Estado interno, para os testes. */
export function retryState() {
	return { armed: timer !== null, attempt };
}

/**
 * Arma a próxima tentativa. Idempotente: se já houver uma armada, não faz nada
 * (não empilha temporizadores). Não faz nada quando a escada está esgotada.
 *
 * @param {() => void} run
 */
export function scheduleDrainRetry(run) {
	if (timer !== null || typeof run !== "function") {
		return;
	}
	if (attempt >= RETRY_BACKOFF_MS.length) {
		return;
	}

	const delay = RETRY_BACKOFF_MS[attempt];
	attempt += 1;
	timer = setTimeout(() => {
		timer = null;
		run();
	}, delay);
}

/**
 * Desarma e zera a escada. Chamado quando a fila fica vazia — o sucesso não
 * pode deixar dívida para trás, senão a próxima falha começava a meio da escada.
 */
export function cancelDrainRetry() {
	if (timer !== null) {
		clearTimeout(timer);
		timer = null;
	}
	attempt = 0;
}
